import { BaseUser } from "@models";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import type { MouseEvent } from "react";
import { UserAvatar } from "src/components/UserAvatar";
import { getUserDisplayName as getDisplayName } from "src/utils/user";

export { getUserDisplayName } from "src/utils/user";

type UserPickerOptionProps = {
  user: BaseUser;
  selected?: boolean;
  highlighted?: boolean;
  itemRef?: (element: HTMLLIElement | null) => void;
  onMouseEnter?: () => void;
  onClick: (event: MouseEvent<HTMLElement>, user: BaseUser) => void;
};

export const UserPickerOption = ({
  user,
  selected = false,
  highlighted = false,
  itemRef,
  onMouseEnter,
  onClick,
}: UserPickerOptionProps) => {
  const displayName = getDisplayName(user);

  return (
    <MenuItem
      ref={itemRef}
      selected={selected || highlighted}
      onMouseEnter={onMouseEnter}
      onClick={(event) => onClick(event, user)}
      sx={
        highlighted
          ? {
              "&.Mui-selected": {
                backgroundColor: "action.hover",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "action.hover",
              },
            }
          : undefined
      }
    >
      <ListItemIcon>
        <UserAvatar
          userId={user.id}
          name={displayName}
          size={21}
          fontSize={9}
        />
      </ListItemIcon>
      <ListItemText
        primary={displayName}
        primaryTypographyProps={{ noWrap: true }}
      />
    </MenuItem>
  );
};
